import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { TextButton, Toast, Typography, useStateInRef } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useNetworkRetry } from '~/hooks/networkRetry/useNetworkRetry';
import { useLocaleKeys } from '~/i18n';
export const GetConnectivityToastTID = (parentTestId)=>getTestIds(parentTestId);
export const ConnectivityToast = (param)=>{
    let { testId, schedule, probe } = param;
    const { ConnectivityToastTestIds } = useMemo(()=>GetConnectivityToastTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('common.connectivity');
    const { native } = useIoContext();
    const { isRetrying, secondsLeft, retryNow } = useNetworkRetry({
        active: true,
        attempt: probe,
        schedule
    });
    const getRetryNow = useStateInRef(retryNow);
    useEffect(()=>native.lifecycle.registerResumeListener(()=>getRetryNow()('foreground')), []);
    return /*#__PURE__*/ _jsx(Toast, {
        type: "warning",
        testId: ConnectivityToastTestIds.Root(),
        text: /*#__PURE__*/ _jsxs(Typography, {
            as: "span",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    as: "span",
                    weight: "bold",
                    children: t.title()
                }),
                ' ',
                t.body(),
                ' ',
                /*#__PURE__*/ _jsx(Typography, {
                    as: "span",
                    "aria-hidden": "true",
                    testId: ConnectivityToastTestIds.Countdown(),
                    children: isRetrying ? t.retrying() : t.retryingIn({
                        seconds: secondsLeft
                    })
                })
            ]
        }),
        action: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'connectivity_retry_now'
            },
            testId: ConnectivityToastTestIds.RetryNow(),
            onClick: ()=>retryNow(),
            children: t.retryNow()
        })
    });
};
